import React from 'react';
import { Text } from '@fluentui/react';

export type TableRowType = Record<string, unknown> | JSX.Element | string;

interface TableRowComponentProps {
  row: TableRowType;
}

export const TableRowComponent: React.FunctionComponent<TableRowComponentProps> = props => {
  return (
    <>
      {Object.keys(props.row).map((key, index) => {
        return (
          <td key={index} className="py-3 px-4">
            <Text variant="medium">{props.row[key]}</Text>
          </td>
        );
      })}
    </>
  );
};
